<template>
    <div class="LegendBar">
        <LegendTag
            v-for="l in legend"
            :key="l.label"
            class="LegendBar__tag"
            :label="l.label"
            :color="l.color"
            :percent="l.percent"
        />
    </div>
</template>
<script>
import LegendTag from './_legend-tag.vue';
export default {
    name: 'LegendBar',
    components: {
        LegendTag
    },
    props: {
        legend: {
            type: Array,
            required: true
        }
    }
};
</script>
<style lang="scss">
    .LegendBar {
        display: flex;
        align-items: center;
        &__tag {
            margin-right: 1rem;
        }
    }
</style>
